import React, { useState, useEffect } from 'react';
import liff from '@line/liff';
import axios from 'axios';

const GoldLiffApp = () => {
  const [profile, setProfile] = useState(null);
  const [gold, setGold] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  const initApp = async () => {
    try {
      await liff.init({ liffId: process.env.REACT_APP_LIFF_ID2 });

      if (!liff.isLoggedIn()) {
        liff.login();
        return; // หยุดการทำงานไว้ก่อนจนกว่าจะ login สำเร็จ
      }

      // 1. ดึงข้อมูล Profile และ ราคาทอง พร้อมกัน
      const [userProfile, goldRes] = await Promise.all([
        liff.getProfile(),
        axios.get('https://api.chnwt.dev/thai-gold-api/latest')
      ]);

      const currentGold = goldRes.data.response;
      
      // อัปเดต State (เพื่อโชว์ในหน้าจอถ้ายังไม่ปิด)
      setProfile(userProfile);
      setGold(currentGold);
      
      await sendLineMessage(userProfile.userId, currentGold);

    } catch (err) {
      console.error("Error:", err);
    } finally {
        // 3. ปิดหน้าต่างทันที
        setTimeout(() => {
          setLoading(false);
          liff.closeWindow();
        }, 300); // หน่วงเวลาเล็กน้อยเพื่อให้แน่ใจว่า axios ทำงานเสร็จสิ้น
    }
  };

  initApp();
}, []);



const sendLineMessage = async (userId, messageText) => {

  try {
     axios.post(process.env.REACT_APP_API+'/golePrice', {
      userId: userId,
      message: messageText
    });
  } catch (err) {
    console.error('Backend error:', err);
  }
};

  if (loading) return <div style={styles.center}>กำลังตรวจสอบข้อมูล...</div>;

  return (
    <></>
    // <div style={styles.container}>
    //   {/* ส่วนแสดงโปรไฟล์ผู้ใช้ LINE */}
    //   {profile && (
    //     <div style={styles.profileBox}>
    //       <img src={profile.pictureUrl} alt="profile" style={styles.avatar} />
    //       <p>สวัสดีคุณ <strong>{profile.displayName}</strong></p>
    //     </div>
    //   )}

    //   <hr style={styles.divider} />

    //   {/* ส่วนแสดงราคาทอง */}
    //   <h2 style={styles.goldHeader}>ราคาทองคำวันนี้</h2>
    //   {gold ? (
    //     <div style={styles.goldGrid}>
    //       <div style={styles.goldCard}>
    //         <h4>ทองคำแท่ง</h4>
    //         <p>ซื้อ: <span style={styles.price}>{gold.price.gold_bar.buy}</span></p>
    //         <p>ขาย: <span style={styles.price}>{gold.price.gold_bar.sell}</span></p>
    //       </div>
    //       <div style={styles.goldCard}>
    //         <h4>ทองรูปพรรณ</h4>
    //         <p>ซื้อ: <span style={styles.price}>{gold.price.gold.buy}</span></p>
    //         <p>ขาย: <span style={styles.price}>{gold.price.gold.sell}</span></p>
    //       </div>
    //       <div style={styles.updateStatus}>
    //         <p>เปลี่ยนแปลง: {gold.price.change} บาท ({gold.update_time})</p>
    //       </div>
    //     </div>
    //   ) : (
    //     <p>ไม่สามารถโหลดข้อมูลราคาทองได้</p>
    //   )}
    // </div>
  );
};

const styles = {
  container: { padding: '20px', fontFamily: 'sans-serif', textAlign: 'center', backgroundColor: '#f9f9f9', minHeight: '100vh' },
  profileBox: { marginBottom: '20px' },
  avatar: { width: '80px', borderRadius: '50%', border: '3px solid #00b900' },
  goldHeader: { color: '#d4af37' },
  goldGrid: { display: 'flex', flexDirection: 'column', gap: '15px' },
  goldCard: { background: '#fff', padding: '15px', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  price: { color: '#b22222', fontWeight: 'bold' },
  divider: { margin: '20px 0', border: '0.5px solid #eee' },
  updateStatus: { fontSize: '0.85rem', color: '#666' },
  closeBtn: { marginTop: '30px', padding: '10px 20px', backgroundColor: '#666', color: '#fff', border: 'none', borderRadius: '5px' },
  center: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }
};

export default GoldLiffApp;